import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { Alert, Table } from 'react-bootstrap';
import '../styles.css';
import { numberFormatCurrency } from '../../../utils/helper';
import moment from 'moment';

const DataTableRow = ({ data, customColumns }) => {
  if (data.type === 'group-total') {
    // add space
  }

  return (
    <tr className={`row-type-${data.type}`} key={data.id}>
      <td>
        {data.type === 'accounts'
          ? `${data.account_code} ${data.account_name}`
          : data.account_name}
      </td>
      {customColumns.map((rowCustomColumn) => (
        <td className="text-right" key={`${data.id}_${rowCustomColumn}`}>
          {numberFormatCurrency(data[rowCustomColumn])}
        </td>
      ))}
    </tr>
  );
};

const DataTableSkeleton = () => {
  return (
    <table class="table-is table">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th class="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
          <th class="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
          <th class="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
          <th class="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="row-type-group">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
        </tr>
        <tr class="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-line_item">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-group">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
        </tr>
        <tr class="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-line_item">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-group">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
        </tr>
        <tr class="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-line_item">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr class="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td class="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const DataTable = ({ isLoading, data, headers, dateFields, params }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        border: '1px solid #f1f1f1',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto 20px',
      }}
    >
      <Box
        p={2}
        sx={{
          marin: '0 auto',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          textAlign: 'center',
        }}
      >
        <div>
          <div>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={220}
                height={25}
                sx={{ margin: '0 auto' }}
              />
            ) : (
              `Bell-Kenz Pharma Inc.`
            )}
          </div>
          <div>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={250}
                height={25}
                sx={{ margin: '0 auto' }}
              />
            ) : (
              `Statement of Comprehensive Income`
            )}
          </div>
          <div>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={230}
                height={25}
                sx={{ margin: '0 auto' }}
              />
            ) : params?.date_from === params?.date_to ? (
              `As of ${moment(params.date_from).format('MMM DD, YYYY')}`
            ) : (
              `${moment(params.date_from).format('MMM DD, YYYY')} - ${moment(
                params.date_to,
              ).format('MMM DD, YYYY')}`
            )}
          </div>
        </div>
      </Box>

      <Box sx={{ overflowX: 'auto', minHeight: '800px' }}>
        {isLoading ? (
          <DataTableSkeleton />
        ) : !data.length ? (
          <Box p={3}>
            <Alert variant="warning">No Data.</Alert>
          </Box>
        ) : (
          <Table className="table-is mb-0" hover>
            <thead>
              <tr>
                <th>&nbsp;</th>
                {headers.map((date) => (
                  <th className="text-right" key={date}>
                    {date}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <DataTableRow data={row} customColumns={dateFields} />
              ))}
            </tbody>
          </Table>
        )}
      </Box>
    </Box>
  );
};

export default DataTable;
